import { Attr, BelongsTo, HasMany, HasOne, Model } from "spraypaint";

import {
  ApplicationRecord,
  objectDirtyChecker,
} from "shared/services/spraypaint";

import type EmailDomain from "./EmailDomain";
import type OrganisationBrand from "./OrganisationBrand";
import type ScheduledReport from "./ScheduledReport";
import type ScheduledReportSpecificationSchedule from "./ScheduledReportSpecificationSchedule";
import type ScheduledReportSpecificationSection from "./ScheduledReportSpecificationSection";
import type Stream from "./Stream";
import type User from "./User";
import type UserAccessible from "./UserAccessible";

@Model()
class ScheduledReportSpecification extends ApplicationRecord {
  static jsonapiType = "scheduled_report_specifications";

  @Attr({ persist: false }) canModify: boolean;

  @Attr({ persist: false }) canShare: boolean;

  @Attr() completedAt: string;

  @Attr() condenseMentions: boolean;

  @Attr({ persist: false }) createdAt: string;

  @Attr() customSender: string;

  @BelongsTo() emailDomain: EmailDomain;

  @Attr() emailDomainId: number;

  @Attr() enabled: boolean;

  @Attr() excludeDuplicateMentions: boolean;

  @Attr() fontSize: string;

  @Attr() footer: string;

  @Attr() groupByMedia: boolean;

  @Attr() header: string;

  @Attr() hideEmptyFolders: boolean;

  @Attr() includeAiSummary: boolean;

  @Attr() includeDailyHighlights: boolean;

  @Attr() includeMediaItems: boolean;

  @Attr() includePdf: boolean;

  @Attr() includePrintClipsPdf: boolean;

  @Attr() language: string;

  @HasOne() lastReport: ScheduledReport;

  @Attr() limitBroadcastPerSection: boolean;

  @Attr({ dirtyChecker: objectDirtyChecker }) mediaOrder: string[];

  @Attr({ dirtyChecker: objectDirtyChecker }) options: Record<string, unknown>;

  @BelongsTo() organisationBrand: OrganisationBrand;

  @Attr() organisationBrandId: number;

  @Attr() organisationTeamId: number;

  @Attr() preferenceOnlineMentions: boolean;

  @Attr() productType: "monitoring" | "social";

  @Attr({ dirtyChecker: objectDirtyChecker }) recipients: string[];

  @HasMany() scheduledReports: ScheduledReport[];

  @HasMany() schedules: ScheduledReportSpecificationSchedule[];

  @HasMany() sections: ScheduledReportSpecificationSection[];

  @Attr() sender: string;

  @Attr() senderEmail: string;

  @Attr() senderName: string;

  @Attr() sendWhenNoMention: boolean;

  @Attr() showExcerpts: boolean;

  @Attr() showKeywordCount: boolean;

  @Attr() showPotentialAudienceReach: boolean;

  @Attr() showRestrictedContent: boolean;

  @Attr() sortBy: string;

  @Attr() sortOrder: string;

  @HasMany() streams: Stream[];

  @Attr({ persist: false }) streamsData: any[];

  @Attr() subject: string;

  @Attr() subjectDate: boolean;

  @Attr() subjectMentionCount: boolean;

  @BelongsTo() user: User;

  @HasMany() userAccessibles: UserAccessible[];

  @Attr() userId: number;
}

export default ScheduledReportSpecification;
